type ImageType = 'jpg' | 'png' | 'gif-static' | 'gif-animated' | 'unknown'
// Derived from https://stackoverflow.com/questions/18299806/how-to-check-file-mime-type-with-javascript-before-upload
export async function imageType(file: File) {
  const arrayBuffer = await file.arrayBuffer()
  const arr = new Uint8Array(arrayBuffer)
  const headerByteLength = 4
  let header = ''

  for (let i = 0; i < headerByteLength; i++) {
    header += arr[i]!.toString(16)
  }

  let type: ImageType = 'unknown'
  switch (header) {
    case '89504e47':
      type = 'png'
      break
    case '47494638':
      type = bufferContainsAnimatedGif(arr) ? 'gif-animated' : 'gif-static'
      break
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      type = 'jpg'
      break
  }
  return type
}

// Derived from https://stackoverflow.com/questions/1326890/is-it-possible-to-detect-animated-gif-images-client-side
function bufferContainsAnimatedGif(arr: Uint8Array) {
  const length = arr.length
  let frames = 0

  // make sure it's a gif (GIF8)
  if (arr[0] !== 0x47 || arr[1] !== 0x49 || arr[2] !== 0x46 || arr[3] !== 0x38) {
    return false
  }

  //ported from php http://www.php.net/manual/en/function.imagecreatefromgif.php#104473
  //an animated gif contains multiple 'frames', with each frame having a
  //header made up of:
  // * a static 4-byte sequence (\x00\x21\xF9\x04)
  // * 4 variable bytes
  // * a static 2-byte sequence (\x00\x2C) (some variants may use \x00\x21 ?)
  // We read through the file til we reach the end of the file, or we've found
  // at least 2 frame headers
  for (let i = 0, len = length - 9; i < len && frames < 2; ++i) {
    if (
      arr[i] === 0x00 &&
      arr[i + 1] === 0x21 &&
      arr[i + 2] === 0xf9 &&
      arr[i + 3] === 0x04 &&
      arr[i + 8] === 0x00 &&
      (arr[i + 9] === 0x2c || arr[i + 9] === 0x21)
    ) {
      frames++
    }
  }

  // if frame count > 1, it's animated
  return frames > 1
}
